import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
const faqs = [['¿Necesito ser especialista en comunicación?', 'No. El kit te enseña paso a paso cómo conversar sobre temas del cuidado.'], ['¿Cuánto tiempo me toma?', 'Podés recorrer el método en 14 días, combinando los contenidos principales con la aplicación práctica de sus herramientas.'], ['¿Garantiza que mi familiar acepte todo?', 'El kit está diseñado para darte herramientas prácticas para preparar conversaciones, expresar tus necesidades y buscar acuerdos sin depender de la improvisación.'], ['¿Es 100% digital?', 'Sí. Acceso inmediato por email en PDF. Podés leerlo desde el celular, tablet o computadora, e imprimirlo si preferís.'], ['¿La garantía es real?', 'Sí. Tenés 14 días de garantía y podés solicitar la devolución dentro de ese período si el kit no es para vos.'], ['¿Puedo usar esto si no tengo un familiar con Párkinson?', 'El kit fue creado específicamente para mujeres que cuidan a un familiar con Párkinson. Sus herramientas se enfocan en situaciones de comunicación y acuerdos dentro del cuidado cotidiano.']] as const;
const costs = ['Otro mes llegando a cada charla sin preparación', 'Discusiones que generan tensión en el vínculo', 'Acuerdos que se olvidan o se reinterpretan', 'Sensación de estar sola en las decisiones', 'Agotamiento emocional sin dirección clara'];
const purchases = [['Sofía M.', 'Buenos Aires'], ['Patricia L.', 'Córdoba'], ['Lorena S.', 'Rosario'], ['Marisa R.', 'Mendoza']];
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-21" data-mp="21ybxcq5b2bpf">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22" data-mp="1e9sreh9qab0i">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-23" data-mp="19br5zpotxzlv" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24" data-mp="1yzv96tpvei67">
            GARANTÍA 14 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-25" data-mp="230oztuup6b2s">
            <p className="text-slate-300" data-id="element-26" data-mp="27rovyxvzsp48">Abrís los volúmenes. Aplicás el método.</p>
            <p className="mt-4 text-slate-300" data-id="element-27" data-mp="2cr0bk3kmhok8">
              Si en 14 días no es lo que esperabas, te devolvemos el 100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-28" data-mp="1g2c7kb5qs1tt">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-29" data-mp="1k4fjt208jag5">sin formularios, sin drama.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-30" data-mp="1p41yzgzmj0rl">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </section>
      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-31" data-mp="30ft0vh6qoy5v">
        <div className="mx-auto max-w-3xl" data-id="element-32" data-mp="35fyv954e8yrn">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-33" data-mp="35entfauie136">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-34" data-mp="tuolzgdxj2bj">
            {faqs.map(([question, answer], index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-35" data-mp="k17s6cdsln7v" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-36" data-mp="b2e0n0fbjn16">
                    <span data-id="element-37" data-mp="3sclv9eig22zr">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-38" data-mp="1vgwgb72s8sa9" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-39" data-mp="23idmbzqwc3j8">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-40" data-mp="1olmrm3s63fzy">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-41" data-mp="1kl3ze8md47x8">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-42" data-mp="10xwh3zq3midv">
      <div className="mx-auto max-w-4xl" data-id="element-43" data-mp="i8jem6ttdsif">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-44" data-mp="i9cld7srwi0k">
          ⚖️ ¿CUÁNTO CUESTA NO TENER EL KIT?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-45" data-mp="r997b1ns32rx">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-46" data-mp="m7jtje968b05">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-47" data-mp="w6hp3150l4sn">
                ×
              </span>
              {item}
            </p>)}
        </div>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-48" data-mp="gjlfbqxypj2t">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-49" data-mp="liy108d3kk3t">
          🎯 KIT ACUERDOS DE CUIDADO™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-50" data-mp="vcybyqv28jkg">
          Metodología práctica para cuidadoras argentinas que quieren preparar
          conversaciones, construir acuerdos y sostenerlos en el cuidado cotidiano.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-51" data-mp="19avee3w73k71">
          “Tus acuerdos no son solo palabras. Son la forma de cuidar el vínculo
          mientras cuidás.”
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-52" data-mp="3b16s9f0r4uzq">
          <a className="hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-53" data-mp="33iqqsq2xxrue">
            📧 soportebiomalivido@gmail.com
          </a>
          <span data-id="element-54" data-mp="2ypny0k5zmmf9">📲 @biomalivido</span>
          <a className="hover:text-brand-light" href="https://biomalivido.com" target="_blank" rel="noreferrer" data-id="element-55" data-mp="2ts4kjmh46dod">
            🌐 biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-56" data-mp="3mg0ewkj7nthz">
          © KIT ACUERDOS DE CUIDADO™ 2026 — Todos los derechos reservados.
        </p>
      </footer>
      <AnimatePresence data-id="element-57" data-mp="3cj5ic76i036c">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-58" data-mp="3chufqaosh1gt">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-59" data-mp="7jy060pb0j">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-60" data-mp="525brishhe53" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-61" data-mp="3n8tbet4rl93d">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-62" data-mp="jphz9d1upty4">
              compró el Kit Acuerdos de Cuidado™
            </p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-63" data-mp="nq1wshqc6zks">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}